<script>
    export default {
        
    }
</script>

<template>
    <div class="card is-flex agenda-item">
        <div class="card-image is-clipped is-relative">
            <picture class="image is-1by1 is-skeleton">
                <img width="288" 
                     height="288">
            </picture>
            <span class="tag">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        </div>
        <div class="card-content is-flex-grow-1 is-flex is-flex-direction-column">
            <div class="block card-date">
                <div class="progress is-small" value="0" max="100"></div>
                <div class="progress is-small" value="0" max="100"></div>
            </div>
            <h3 class="title is-5">
                <div class="progress" value="0" max="100"></div>
            </h3>
            <div class="block">
                <div class="has-text-size-small"><div class="progress is-small" value="0" max="100"></div></div>
            </div>
            <div class="block mt-auto">
                <button class="button is-grey is-fullwidth is-justify-content-center card-cta">
                    <div class="progress is-small" value="0" max="100"></div>
                </button>
            </div>
        </div>
    </div>
</template>
